var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TeacherNav'),_c('router-view'),_c('FooterComp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }